import React from "react";
import useRouter from "../../hooks/router";

const DARK_BG = "#111e27";
const NAV_BG = "#1a3a4a";
const CARD_BG = "#1e3547";
const TEXT_MAIN = "#e8f0f4";
const TEXT_MUTED = "#8fafc4";
const BORDER = "rgba(255,255,255,0.12)";
const ACCENT = "#00c9a7";

const NotFound = () => {
  const { handleNavigation } = useRouter();

  return (
    <div style={{ background: DARK_BG, minHeight: "100vh" }} className="font-outfit flex flex-col">
      <nav style={{ background: NAV_BG, borderBottom: `1px solid ${BORDER}` }} className="w-full px-6 py-4 flex items-center justify-between shadow-md">
        <img src="/logo.svg" alt="RefAlign" className="h-9 cursor-pointer" onClick={() => handleNavigation("/")} />
        <button
          onClick={() => handleNavigation("/signup")}
          style={{ background: ACCENT, color: "#0d2230" }}
          className="px-4 py-2 rounded-lg text-sm font-semibold hover:opacity-90 transition-all"
        >
          Get Started Free
        </button>
      </nav>

      <main className="flex-1 px-4 sm:px-6 py-16 flex items-center justify-center">
        <div style={{ background: CARD_BG, border: `1px solid ${BORDER}` }} className="max-w-xl w-full rounded-3xl p-8 text-center shadow-2xl">
          <div style={{ color: ACCENT }} className="text-sm font-semibold uppercase tracking-widest mb-3">404</div>
          <h1 style={{ color: TEXT_MAIN }} className="text-3xl sm:text-4xl font-bold mb-3">That page doesn’t exist</h1>
          <p style={{ color: TEXT_MUTED }} className="text-base sm:text-lg mb-8 leading-relaxed">
            The link looks wrong or the page was moved. Head back home, check pricing, or get started.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button onClick={() => handleNavigation("/")} style={{ background: ACCENT, color: "#0d2230" }} className="px-6 py-3 rounded-xl font-bold hover:opacity-90 transition-all">
              Go Home
            </button>
            <button onClick={() => handleNavigation("/pricing")} style={{ color: TEXT_MAIN, border: `1px solid ${BORDER}` }} className="px-6 py-3 rounded-xl font-medium hover:bg-white hover:bg-opacity-5 transition-all">
              Pricing
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default NotFound;
